import UI_ACTIONS from '../../constants/actions/ui'

class UiAction {
    static toggleDrawer = () => ({
        type: UI_ACTIONS.TOGGLE_DRAWER
    });

}

export default UiAction;



// WEBPACK FOOTER //
// ./src/redux/actions/ui.js